export const lightMapStyle = [
  {
    featureType: "transit.station",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "all",
    elementType: "geometry.fill",
    stylers: [
      { saturation: -68 },
      { lightness: -4 },
      { gamma: 0.72 },
      { color: "#ffffff" },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [{ color: "#000000" }],
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry.fill",
    stylers: [{ color: "#eeeeee" }],
  },
  {
    featureType: "poi",
    elementType: "geometry.fill",
    stylers: [{ color: "#ded8c9" }, { saturation: "0" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry.fill",
    stylers: [{ color: "#c3e5bc" }, { saturation: "0" }],
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [{ color: "#cccccc" }, { saturation: "0" }],
  },
  {
    featureType: "transit",
    elementType: "labels.text.stroke",
    stylers: [
      { saturation: -64 },
      { hue: "#ff9100" },
      { lightness: 16 },
      { gamma: 0.47 },
      { weight: 2.7 },
    ],
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [
      { lightness: -48 },
      { hue: "#ff5e00" },
      { gamma: 1.2 },
      { saturation: -23 },
    ],
  },
  {
    featureType: "transit.station.airport",
    elementType: "geometry.fill",
    stylers: [{ color: "#ded8c9" }, { saturation: "0" }],
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [{ gamma: 0.44 }, { saturation: "-33" }, { color: "#bbddff" }],
  },
  {
    featureType: "poi",
    elementType: "labels.icon",
    stylers: [{ color: "#a9a9a9" }],
  },
];
